import React from 'react'
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import cx from 'classnames';
import './IconFileType.css';



/**
 * A simple IconFileType. Place SVG files in svg folder.
 */

const IconFileType = ({ className, filetype, size, ...otherProps }) => {
  
    const existingTypes = ["csv","doc","mp3","mp4","pdf","txt","xls","xml","zip"];
    if(existingTypes.indexOf(filetype)===-1) {
      filetype = 'file';
    }
    const requireSVGs = require.context("./svg", false, /\.svg$/);
    const icn = requireSVGs(`./${filetype}.svg`);
    return (<div
              style={{
                width: size
              }}
              className={cx({
                [`iconfiletype--${filetype}`]: true,
                'iconfiletype': true
              })}
              {...otherProps}
            >
            <SVGInline svg={ icn } style={{width:size}} />
          </div>)
}

IconFileType.propTypes = {
  /** actual filetype of the IconFileType, will be used as reference for the filetype `filetype.svg` */
  filetype: PropTypes.string.isRequired,
  /** width of displayed IconFileType */
  size: PropTypes.string,
  /** additional classnames, optional */
  className: PropTypes.string,
}

IconFileType.defaultProps = {
  filetype: 'file',
  size: '105px',
  className: ''
};

export default IconFileType;



// WEBPACK FOOTER //
// ./src/components/atoms/IconFileType/IconFileType.js